import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CSpinner
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class DisciplineCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false,
      fields: [],
      creating: false
    };

    this.formRef = React.createRef();
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    this.setState({ loading: true }, () => {
      axios
        .get(`${URL.api}configuration/module/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(respcomercial => {
          if (respcomercial.data.success) {
            axios
              .get(`${URL.api}classification/learning_area/list`, {
                headers: { authorization: `Bearer ${this.props.user.token}` }
              })
              .then(resplearningarea => {
                let fieldsArray = this.fieldsMount(
                  respcomercial.data.data,
                  resplearningarea.data.data
                );
                this.setState(
                  () => ({
                    fields: fieldsArray
                  }),
                  () => {
                    if (!id) {
                      this.setState(() => ({
                        loading: false
                      }));
                    }
                  }
                );
              });
          }
        });
    });

    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}classification/discipline/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              if (resp.data.success) {
                this.setState(
                  () => ({
                    discipline: resp.data.data
                  }),
                  () => {
                    this.setState(() => ({
                      edit: true,
                      loading: false
                    }));
                  }
                );
              }
            });
        }
      );
    }
  }

  fieldsMount(comercial, learningArea) {
    let optionsComercialArray = [];
    for (let i = 0; i < comercial.length; i++) {
      let obj = {
        value: comercial[i].id,
        label: comercial[i].name,
        name: comercial[i].name
      };
      optionsComercialArray[i] = obj;
    }
    let optionsLearninAreaArray = [];
    for (let i = 0; i < learningArea.length; i++) {
      let obj = {
        value: learningArea[i].id,
        label: learningArea[i].name,
        name: learningArea[i].name
      };
      optionsLearninAreaArray[i] = obj;
    }
    let Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      },
      {
        name: "abbreviation",
        label: "Abreviação",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "learning_area_id",
        label: "Área do conhecimento",
        type: "select",
        required: true,
        icon: "fa fa-text-width",
        options: optionsLearninAreaArray,
        validate: [required]
      },
      {
        name: "module_id",
        label: "Módulo",
        type: "select",
        required: true,
        options: optionsComercialArray,
        icon: "fa fa-text-width"
      }
    ];
    return Fields;
  }

  enviar(value) {
    this.setState({ creating: true });

    let obj = {
      name: value.name,
      abbreviation: value.abbreviation,
      learning_area_id: value.learning_area_id,
      module_id: value.module_id
    };

    axios
      .post(`${URL.api}classification/discipline/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/discipline/list");
            this.setState({ creating: false });
          } else {
            this.error("Não foi possível criar a disciplina");
            this.setState({ creating: false });
          }
        },
        () => {
          this.error("Não foi possível criar a disciplina");
          this.setState({ creating: false });
        }
      );
  }

  atualizar(value) {
    this.setState({ creating: true });

    let obj = {
      name: value.name,
      abbreviation: value.abbreviation,
      learning_area_id: value.learning_area_id,
      module_id: value.module_id
    };

    axios
      .post(`${URL.api}classification/discipline/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/discipline/list");
            this.setState({ creating: false });
          } else {
            this.error("Não foi possível criar a disciplina");
            this.setState({ creating: false });
          }
        },
        () => {
          this.error("Não foi possível criar a disciplina");
          this.setState({ creating: false });
        }
      );
  }

  filterGenerate() {}

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/discipline/list", to: "/discipline/list" }]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Disciplina" : "Criar Disciplina"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite a disciplina selecionada"
                    : "Crie uma nova disciplina"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={this.state.fields}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.discipline}
                edit={this.state.edit}
                ref={this.formRef}
              />
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DisciplineCreate);
